/**
 * Espelho local de `robo/ownership.nome_valido`, para dar MENSAGEM melhor.
 *
 * Nao e' autorizacao: quem decide continua sendo o `422 nome_invalido` do
 * backend. Existe porque "nome_invalido" cru nao diz o que arrumar.
 *
 * Recusa, nao normaliza — igual ao backend. Colapsar `\n` num espaco deixaria
 * o nome valido e esconderia que alguem colou um bloco de texto num campo de
 * nome, e e' exatamente a quebra de linha que separa instrucoes dentro de um
 * system prompt.
 */
export const LIMITE_NOME = 40

/**
 * Espelha `^[^\W\d_][\w '\-]*$` com `re.UNICODE`.
 *
 * **Nao da' para traduzir `\w` literalmente:** em JavaScript `\w` e' ASCII puro
 * (`[A-Za-z0-9_]`) mesmo com a flag `u`, enquanto em Python com `re.UNICODE`
 * ele inclui letra acentuada. Copiar a regex do backend faria o espelho recusar
 * `Fê` — um nome que o backend aceita — e o campo diria "caractere invalido"
 * sobre o nome mais provavel de todos. Por isso aqui vai `\p{L}`/`\p{N}`.
 */
const PRIMEIRA_LETRA = /^[\p{L}\p{M}]/u
const CORPO = /^[\p{L}\p{M}\p{N} '-]*$/u

export type ProblemaNome = null | 'vazio' | 'longo' | 'controle' | 'comeca_errado' | 'caractere'

export function problemaNoNome(bruto: string): ProblemaNome {
  const normalizado = (bruto ?? '').normalize('NFC')
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001F\u007F]/.test(normalizado)) return 'controle'
  const nome = normalizado.replace(/\s+/g, ' ').trim()
  if (nome.length === 0) return 'vazio'
  if (nome.length > LIMITE_NOME) return 'longo'
  if (!PRIMEIRA_LETRA.test(nome)) return 'comeca_errado'
  if (nome.includes('_') || !CORPO.test(nome)) return 'caractere'
  return null
}

const MENSAGENS: Record<Exclude<ProblemaNome, null>, string> = {
  vazio: 'O nome não pode ficar em branco.',
  longo: `No máximo ${LIMITE_NOME} caracteres.`,
  controle: 'Há quebra de linha ou caractere de controle no nome. Digite o nome, não cole um texto.',
  comeca_errado: 'O nome precisa começar com uma letra.',
  caractere: 'Use letras, números, espaço, apóstrofo e hífen. Underscore e pontuação não entram.',
}

export function mensagemDoNome(bruto: string): string | null {
  const p = problemaNoNome(bruto)
  return p === null ? null : MENSAGENS[p]
}

/**
 * Como CHAMAR um robo numa lista, num titulo ou num dialogo de confirmacao.
 *
 * Existe porque o nome vazio passou a ser um estado real: desde a TASK-11959 o
 * "Comecar de novo" devolve o robo ao estado de fabrica e `robos.name` fica `''`
 * (a coluna e' `NOT NULL`, entao nao ha NULL a tratar). Sem isto a tela escrevia
 * "**** vai esquecer as redes" — negrito vazio sobre um cadastro que nao existe
 * mais.
 *
 * Nao e' o `rotuloDoRobo` de `avisoDoAjuste.ts`: aquele nomeia o MODELO ("Robo I",
 * "Robo II"), nao o aparelho.
 */
export function nomeOuFallback(robo: { name: string }): string {
  return robo.name.trim() || 'Robô sem nome'
}
